<template>
	<main id="container" class="page-container">
		<div class="page-header">
			<div class="container">
				<div class="display-flex is-between">
					<page-header title="이벤트" />
				</div>
			</div>
		</div>
		<div class="page-content event-check event-sns">
			<div class="container">
				<div class="page-sub-header">
					<h3 class="page-sub-title"><span class="prima">동행축제 이벤트에 참여하고</span> 푸짐한 선물 받으세요.</h3>
				</div>
			</div>
			<div class="page-tab-container">
				<div class="container tab-buttons">
					<router-link to="eatingOut" class="tab-button">외식 활성화</router-link>
					<router-link to="check" class="tab-button">출석체크</router-link>
					<router-link to="ranking" class="tab-button">랭킹게임</router-link>
					<router-link to="dibs" class="tab-button">찜하기</router-link>
					<router-link to="sns" class="tab-button is-active">구매후기</router-link>
					<router-link to="delivery" class="tab-button">공공배달앱 이용후기</router-link>
					<router-link to="challenge" class="tab-button">동행 숨결 챌린지</router-link>
				</div>
			</div>
			<div class="container">
				<div class="event-check-container">
					<div class="event-check-header">
						<div class="event-check-header-img">
							<div class="banner-img">
								<img src="@/assets/img/event/event2412_3_2.jpg" alt="EVENT 04 구매후기 이벤트" />
							</div>
						</div>
						<div class="event-check-header-info">
							<ul class="event-check-header-info-list">
								<li v-for="(item, idx) in infoList" :key="idx">
									<span class="infolist-title">{{ item.title }}</span>
									<span class="infolist-text">{{ item.detail }}</span>
								</li>
							</ul>
						</div>
					</div>
					<div class="event-check-guide">
						<span class="event-check-guide-title">참여방법</span>
						<div class="event-check-guide-desc no-border">
							<ul class="event-check-guide-desclist">
								<li class="event-check-guide-desclist-li">
									<div class="event-check-guide-desclist-img hidden-mobile">
										<img src="@/assets/img/event/icon_e31.png" alt="" />
									</div>
									<div class="event-check-guide-desclist-text">
										<span class="desclist-title">STEP 1</span>
										<span class="desclist-text">홈페이지에서 동행제품을 둘러보고 구매하세요. </span>
									</div>
								</li>
								<li class="event-check-guide-desclist-li">
									<div class="event-check-guide-desclist-img hidden-mobile">
										<img src="@/assets/img/event/icon_e32.png" alt="" />
									</div>
									<div class="event-check-guide-desclist-text">
										<span class="desclist-title">STEP 2</span>
										<span class="desclist-text">구매한 제품 사진과 함께 후기를 본인 SNS에 <strong class="color-yellow">필수 해시태그</strong>와 함께 게시하세요. </span>
										<div class="desclist-tag">
											<span class="tag-title">필수 해시태그</span>
											<div class="tag-item">
												<span class="tag-desc">2024동행축제</span>
												<span class="tag-desc">동행제품</span>
												<span class="tag-desc">구매후기</span>
											</div>
										</div>
									</div>
								</li>
								<li class="event-check-guide-desclist-li">
									<div class="event-check-guide-desclist-img hidden-mobile">
										<img src="@/assets/img/event/icon_e33.png" alt="" />
									</div>
									<div class="event-check-guide-desclist-text">
										<span class="desclist-title">STEP 3</span>
										<span class="desclist-text">홈페이지 이벤트 안내 페이지 내 구매후기 인증 네이버폼을 확인하세요. </span>
									</div>
								</li>
								<li class="event-check-guide-desclist-li">
									<div class="event-check-guide-desclist-img hidden-mobile">
										<img src="@/assets/img/event/icon_e34.png" alt="" />
									</div>
									<div class="event-check-guide-desclist-text">
										<span class="desclist-title">STEP 4</span>
										<span class="desclist-text">구매 내용(주문 명세 화면 캡처)과 함께 게시물을 업로드 한 SNS 링크를 네이버폼을 통해 등록하면 참여 완료됩니다.</span>
										<div class="desclist-tag">
											<span class="tag-title">네이버폼</span>
											<div class="tag-item">
												<span class="desc">성함, 연락처, 구매내용사진, SNS 게시글 링크, 만 14세 이상 체크</span>
											</div>
										</div>
									</div>
								</li>
							</ul>
						</div>
					</div>
					<div class="event-check-products">
						<span class="event-check-products-title">경품소개</span>
						<ul class="event-check-products-list">
							<li class="event-check-products-list-li" v-for="(item, idx) in prdList" :key="idx">
								<div class="event-check-products-item">
									<div class="event-check-products-item-img">
										<img :src="require(`@/assets/img/main/${item.img}`)" :alt="item.title" />
									</div>
									<div class="event-check-products-item-title">
										<span class="item-title-wrap">
											<span class="item-title">{{ item.title }}</span>
											<span class="item-title boldtxt">{{ item.person }}</span>
										</span>
									</div>
								</div>
							</li>
						</ul>
					</div>
				</div>
			</div>
			<div class="event-check-button-box">
				<div class="container flex-column">
					<span class="event-check-prect-title">경품발송</span>
					<ul class="event-check-prect-list">
						<li class="event-check-prect-list-li" v-for="(item, idx) in deliveryList" :key="idx">
							<span class="prect-list-text" v-html="item"></span>
						</li>
					</ul>
					<button type="button" v-if="isShowBtn" class="event-check-button" @click="clickLink('https://naver.me/GDaiLv5d')">구매후기 이벤트 참여</button>
				</div>
			</div>
			<div class="event-check-prect">
				<div class="container">
					<span class="event-check-prect-title">유의사항</span>
					<ul class="event-check-prect-list">
						<li class="event-check-prect-list-li" v-for="(item, idx) in prectList" :key="idx">
							<span class="prect-list-text">{{ item }}</span>
						</li>
					</ul>
				</div>
			</div>
		</div>
	</main>
</template>

<script>
import PageHeader from '@/components/content/PageHeader';
export default {
	name: 'EventSns',
	components: { PageHeader },
	data: () => ({
		visibleModal: false,
		infoList: [
			{
				title: '참여기간',
				detail: '2024년 12월 1일(일) ~ 2024년 12월 28일(토)',
			},
			{
				title: '결과발표',
				detail: '2025년 1월 중',
			},
			{
				title: '경품발송',
				detail: '2025년 2월 중',
			},
			{
				title: '진행방식',
				detail: '동행축제 홈페이지 가입 없이 동행제품 카테고리에서 연결된 구매 페이지를 통해 구매 후 참여, 개인 SNS 계정으로 후기 인증 및 네이버폼을 통하여 응모',
			},
		],
		prdList: [
			{
				img: 'item_image_6.jpg',
				title: '동행제품 선물박스 20만원 상당',
				person: '(2명)',
			},
			{
				img: 'item_image_10.jpg',
				title: '온누리상품권 5만원',
				person: '(10명)',
			},
			{
				img: 'item_image_10.jpg',
				title: '온누리상품권 1만원',
				person: '(20명)',
			},
			{
				img: 'item_image_7.jpg',
				title: '커피 기프티콘',
				person: '(50명)',
			},
		],
		deliveryList: ['구매후기 참여자 대상으로 추첨을 통해 당첨자 선정', '5만원 이하 경품 : 네이버폼 등록 시 기재한 번호로 모바일 쿠폰 전송', '5만원 초과 경품 : 개별 연락 후 제세공과금(22%) 납부 안내 및 네이버폼 링크 안내 (배송지 정보) > 제세공과금 납부 확인 후 경품 택배 발송'],

		prectList: ['본 이벤트는 동행제품을 구매하고, 개인 SNS 계정에 필수 해시태그와 함께 게시물을 등록해 주신 후 홈페이지 이벤트 안내 페이지 내에 [구매후기 이벤트 참여] 버튼을 클릭하여 네이버폼에 접수해 주시면 응모됩니다.', '구매후기 SNS 게시물은 당첨 시까지 유지해야 응모자 확인이 가능합니다.', '이벤트 참여 응모를 위한 네이버폼으로 취합된 개인정보는 이벤트 경품 발송 절차가 모두 완료된 이후에 즉시 폐기 됩니다.', '지급된 쿠폰 사용 시, 쿠폰 내 유의사항을 반드시 확인 바랍니다.', '당첨 쿠폰이 분실, 도난당한 경우, 재발급이 불가합니다. (당첨 쿠폰 복사 및 저장 필수)', '5만원 초과 경품 당첨의 경우 제세공과금(22%)은 본인이 부담해야 합니다.', '당첨자는 이벤트 종료 후 1개월 이내 공지될 예정입니다.', '당첨자의 잘못된 정보 입력으로 인해 경품 누락이 될 경우 재발송되지 않습니다.', '해당 이벤트에 만 14세 미만은 참여할 수 없습니다. (만 14세 미만 참여자의 경우 경품 당첨이 취소됩니다.)', '이벤트 일정 및 경품 내용은 추후 주최 측의 사정에 따라 변동할 수 있습니다.', '게임 이벤트에 관한 문의는 게임 운영 대행사인 지엠컴 070-4838-6391로 문의 바라며, 상담 가능 시간은 평일 오전 9시 ~ 오후 6시입니다. '],
		eventStart: false,
	}),
	computed: {
		isShowBtn() {
			return new Date() < new Date("2024-12-29 00:00:00")
		}
	},
	watch: {},
	mounted() {
		this.$nextTick(() => {
			setTimeout(() => {
				const thisTab = document.querySelector('.tab-button.is-active');
				thisTab.scrollIntoView({ behavior: 'smooth', block: 'center' });
			}, 100);
		});
	},
	methods: {
		clickLink(url) {
			window.open(url, '_blank');
		},
		clickEvent(e) {
			let url = 'https://naver.me/GDaiLv5d';
			const w = 560;
			const h = 600;
			const title = '이벤트';

			// 브라우저 창의 크기 가져오기
			const dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : window.screenX;
			const dualScreenTop = window.screenTop !== undefined ? window.screenTop : window.screenY;

			const width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
			const height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;

			// 팝업창의 중앙 좌표 계산
			const left = width / 2 - w / 2 + dualScreenLeft;
			const top = height / 2 - h / 2 + dualScreenTop;

			// 팝업창 설정
			const options = `
				scrollbars=yes,
				width=${w}, 
				height=${h}, 
				top=${top}, 
				left=${left},
				status=no,
				menubar=no,
				toolbar=no,
				location=no,
				directories=no,
				copyhistory=no
			`.replace(/\s+/g, '');

			// 팝업창 열기
			const newWindow = window.open(url, title, options);

			// 팝업창이 차단되었는지 확인
			if (window.focus && newWindow) {
				newWindow.focus();
			}

			return newWindow;
		},
	},
};
</script>
